module.exports = __webpack_public_path__ + "assets/img/4.d1c0744c.png";